import React from 'react';
import "./LayoutDefault.css"

import LayoutBackground from 'Components/LayoutBackground/LayoutBackground';
import Header from 'Components/Header/header';
import Profile from 'Components/SideBar/SideBarComponents/Profile/Profile';

const LayoutDefault = ({ children }) => {
    return (
        <>
            <Header>
                <Profile />
            </Header>
            <div id='layout-default'>
                <LayoutBackground />
                <main id='panel-layout-default'>
                    {children}
                </main>
            </div>
        </>
    );
};

export default LayoutDefault;